import * as React from 'react';
import ChatbotPanel from './ChatbotPanel';
import { AnalyseDocPage } from './AnalyseDocPage';
import { MesClausesPage } from './MesClausesPage';
import { MesContratsPage } from './MesContratsPage';
import { EnrichirPage } from './EnrichirPage';
import { NotificationsPage } from './NotificationsPage';
import { CompanySelectionPage } from './CompanySelectionPage';
import { useAppContext } from '../context/AppContext';
import '../styles/MainEditorView.css';

export const MainEditorView: React.FC = () => {
  const { activePage } = useAppContext();

  // Toutes les pages sont gardées montées pour préserver leur état
  // On utilise CSS pour afficher/masquer selon la page active
  return (
    <div className="main-editor-view-container">
      {/* Page Chat */}
      <div className={`page-container ${activePage === 'chat' ? 'page-active' : 'page-hidden'}`}>
        <div className="app-container" style={{ height: '100%', display: 'flex', background: '#ffffff' }}>
          <main className="main-panel" style={{ width: '100%' }}>
            <ChatbotPanel />
          </main>
        </div>
      </div>

      {/* Page Analyse de doc */}
      <div className={`page-container ${activePage === 'analyse-doc' ? 'page-active' : 'page-hidden'}`}>
        <AnalyseDocPage />
      </div>

      {/* Page Mes Clauses */}
      <div className={`page-container ${activePage === 'page3' ? 'page-active' : 'page-hidden'}`}>
        <MesClausesPage />
      </div>

      {/* Page Mes Contrats */}
      <div className={`page-container ${activePage === 'page4' ? 'page-active' : 'page-hidden'}`}>
        <MesContratsPage />
      </div>

      {/* Page Enrichir */}
      <div className={`page-container ${activePage === 'enrichir' ? 'page-active' : 'page-hidden'}`}>
        <EnrichirPage />
      </div>

      {/* Page Notifications */}
      <div className={`page-container ${activePage === 'notifications' ? 'page-active' : 'page-hidden'}`}>
        <NotificationsPage />
      </div>

      {/* Page Company Selection (hidden from nav, admin only) */}
      <div className={`page-container ${activePage === 'company-selection' ? 'page-active' : 'page-hidden'}`}>
        <CompanySelectionPage />
      </div>
    </div>
  );
};
